export const SLB = "SLB"
export const SLBBILLING = "SLBBILLING"